import jsonp from 'jsonp'
import axios from 'axios'

class ShopifyCart {

    constructor() {
        this.loading = false
    }

    clear() {
        return new Promise((resolve, reject) => {
            jsonp('https://shop.vox-sprachschule.ch/cart/clear.json', null, (err, data) => {
                if (err) {
                    reject(err)
                } else {
                    resolve(data)
                }
            })
        })
    }

    addLineItem(lineItem) {
        return new Promise((resolve, reject) => {
            fetch('https://shop.vox-sprachschule.ch/cart/add.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify([lineItem])
            })
                .then(response => {
                    resolve(response.json())
                })
                .catch((error) => {
                    reject(error)
                });
        })
    }

    serialize(obj, prefix) {
        let str = [],
            p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                let k = prefix ? prefix + "[" + p + "]" : p,
                    v = obj[p];
                str.push((v !== null && typeof v === "object") ?
                    this.serialize(v, k)
                    : encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
    }

    async proceedToCheckout(event) {
        event.preventDefault()
        event.stopPropagation()

        if (this.loading) {
            return
        }

        this.loading = true

        const button = event.target
        const loadingIcon = document.createElement('div')
        loadingIcon.innerHTML = '<span class="spinner-border spinner-border-sm mr-2 align-baseline" role="status" aria-hidden="true"></span>'
        button.insertBefore(loadingIcon.firstChild, button.firstChild);

        if (button.dataset.checkout) {
            this.loading = true
            window.location.href = button.dataset.checkout
            return
        }

        if (button.dataset.quote) {
            this.loading = true
            window.location.href = await this.getQuoteDraftOrderUrl(button.dataset.quote)
            return
        }

        const productJson = button.dataset.product
        let lineItem = JSON.parse(productJson)

        if (lineItem && lineItem.id) {
            try {
                await this.clear()
                await this.addLineItem(lineItem)
                window.location = 'https://shop.vox-sprachschule.ch/checkout'
            } catch (error) {
                return error
            }
        }
    }

    async getQuoteDraftOrderUrl(quoteId) {
        console.log('getQuoteDraftOrderUrl', quoteId)
        try {
            const form = document.querySelector('#buy-modal form')
            const formData = new FormData(form)
            const endpoint = '/api/quote/' + quoteId
            const response = await axios.post(endpoint, formData)
            console.log('ASDA', response.data)
            if (response.data && response.data.draft_order_url) {
                return response.data.draft_order_url
            }
        } catch (error) {
            console.error(error)
            return error
        }
    }

    async proceedToExamRegistrationCheckout(event) {
        event.preventDefault()
        event.stopPropagation()

        console.log('proceedToExamRegistrationCheckout')
        if (this.loading) {
            return
        }

        this.loading = true

        const form = document.querySelectorAll('#exam-registration-modal form')[0]
        form.classList.add('was-validated');
        if (form.checkValidity() === false) {
            return
        }

        const button = event.target
        button.disabled = true
        button.innerHTML = 'Redirecting. Please wait...'
        const loadingIcon = document.createElement('div')
        loadingIcon.innerHTML = '<span class="spinner-border spinner-border-sm mr-2 align-baseline" role="status" aria-hidden="true"></span>'
        button.insertBefore(loadingIcon.firstChild, button.firstChild);

        const exam = button.dataset.exam
        try {
            const formData = new FormData(form)
            formData.append('exam', exam)
            const endpoint = '/api/exams_list/create_draft_order'
            console.log(formData)
            const response = await axios.post(endpoint, formData)
            console.log(response.data)
            if (response.data && response.data.draft_order_url) {
                window.location = response.data.draft_order_url
            }
        } catch (error) {
            console.error(error)
            return error
        }
    }

    showAddToCartModal(event) {
        event.preventDefault()
        event.stopPropagation()

        const button = event.target
        const modal = document.getElementById('buy-modal')
        const productJson = button.dataset.product

        modal.querySelector('.additional_gtc').innerHTML = button.dataset.gtc ?? ''

        const proceedToCheckoutButton = modal.querySelector('.proceed-to-checkout')
        proceedToCheckoutButton.dataset.product = productJson
        proceedToCheckoutButton.disabled = true

        const gtcCheckbox = modal.querySelector('.gtc-approved-checkbox')
        const privacyCheckbox = modal.querySelector('.privacy-approved-checkbox')

        if (gtcCheckbox) {
            gtcCheckbox.checked = false
            gtcCheckbox.addEventListener('change', (event) => {
                if (privacyCheckbox) {
                    if (privacyCheckbox.checked) {
                        proceedToCheckoutButton.disabled = !proceedToCheckoutButton.disabled
                    }
                } else {
                    proceedToCheckoutButton.disabled = !proceedToCheckoutButton.disabled
                }
            })
        }

        if (privacyCheckbox) {
            privacyCheckbox.checked = false
            privacyCheckbox.addEventListener('change', (event) => {
                if (gtcCheckbox) {
                    if (gtcCheckbox.checked) {
                        proceedToCheckoutButton.disabled = !proceedToCheckoutButton.disabled
                    }
                } else {
                    proceedToCheckoutButton.disabled = !proceedToCheckoutButton.disabled
                }
            })
        }


        $('#buy-modal').modal('show')
    }

    showCheckoutModal(event) {
        event.preventDefault()
        event.stopPropagation()

        const button = event.target
        const modal = document.getElementById('buy-modal')
        const checkoutUrl = button.dataset.checkout

        modal.querySelector('.additional_gtc').innerHTML = button.dataset.gtc ?? ''

        const proceedToCheckoutButton = modal.querySelector('.proceed-to-checkout')
        proceedToCheckoutButton.dataset.checkout = checkoutUrl
        proceedToCheckoutButton.disabled = true

        const gtcCheckbox = modal.querySelector('.gtc-approved-checkbox')
        const privacyCheckbox = modal.querySelector('.privacy-approved-checkbox')

        if (gtcCheckbox) {
            gtcCheckbox.checked = false
            gtcCheckbox.addEventListener('change', (event) => {
                if (privacyCheckbox) {
                    if (privacyCheckbox.checked) {
                        proceedToCheckoutButton.disabled = !proceedToCheckoutButton.disabled
                    }
                } else {
                    proceedToCheckoutButton.disabled = !proceedToCheckoutButton.disabled
                }
            })
        }

        if (privacyCheckbox) {
            privacyCheckbox.checked = false
            privacyCheckbox.addEventListener('change', (event) => {
                if (gtcCheckbox) {
                    if (gtcCheckbox.checked) {
                        proceedToCheckoutButton.disabled = !proceedToCheckoutButton.disabled
                    }
                } else {
                    proceedToCheckoutButton.disabled = !proceedToCheckoutButton.disabled
                }
            })
        }

        $('#buy-modal').modal('show')
    }

    showExamRegistrationModal(event) {
        event.preventDefault()
        event.stopPropagation()

        const button = event.target
        const exam = button.dataset.exam
        const modal = document.getElementById('exam-registration-modal')

        const form = modal.querySelector('form')
        if (form) {
            form.classList.remove('was-validated')
        }

        const proceedToCheckoutButton = modal.querySelector('.js-submit-exam-registration')
        proceedToCheckoutButton.disabled = true
        proceedToCheckoutButton.dataset.exam = exam

        const gtcCheckbox = modal.querySelector('.gtc-approved-checkbox')
        const privacyCheckbox = modal.querySelector('.privacy-approved-checkbox')
        const telcPrivacyCheckbox = modal.querySelector('.telc-privacy-approved-checkbox')

        const areAllCheckboxesChecked = () => {
            return gtcCheckbox.checked && privacyCheckbox.checked && telcPrivacyCheckbox.checked
        }

        telcPrivacyCheckbox.checked = false
        telcPrivacyCheckbox.addEventListener('change', (event) => {
            proceedToCheckoutButton.disabled = !areAllCheckboxesChecked()
        })

        gtcCheckbox.checked = false
        gtcCheckbox.addEventListener('change', (event) => {
            proceedToCheckoutButton.disabled = !areAllCheckboxesChecked()
        })

        privacyCheckbox.checked = false
        privacyCheckbox.addEventListener('change', (event) => {
            proceedToCheckoutButton.disabled = !areAllCheckboxesChecked()
        })

        $('#exam-registration-modal').modal('show')
    }

    bindPageHandlers() {
        const addToCartButtons = document.querySelectorAll('.js-add-to-cart')
        if (addToCartButtons.length > 0) {
            Array.prototype.forEach.call(addToCartButtons, (el, i) => {
                el.addEventListener('click', (event) => {
                    //this.processClickEvent(event)
                    this.showAddToCartModal(event)
                })
            })
        }

        const popupOpenCheckout = document.querySelectorAll('.js-checkout')
        if (popupOpenCheckout.length > 0) {
            Array.prototype.forEach.call(popupOpenCheckout, (el, i) => {
                el.addEventListener('click', (event) => {
                    //this.processClickEvent(event)
                    this.showCheckoutModal(event)
                })
            })
        }

        const proceedToCheckoutButtons = document.querySelectorAll('.proceed-to-checkout')
        if (proceedToCheckoutButtons.length > 0) {
            Array.prototype.forEach.call(proceedToCheckoutButtons, (el, i) => {
                el.addEventListener('click', (event) => {
                    this.proceedToCheckout(event)
                })
            })
        }

        const popupOpenExamRegistration = document.querySelectorAll('.js-exam-registration')
        if (popupOpenExamRegistration.length > 0) {
            Array.prototype.forEach.call(popupOpenExamRegistration, (el, i) => {
                el.addEventListener('click', (event) => {
                    this.showExamRegistrationModal(event)
                })
            })
        }

        const submitExamRegistrationButtons = document.querySelectorAll('.js-submit-exam-registration')
        if (submitExamRegistrationButtons.length > 0) {
            Array.prototype.forEach.call(submitExamRegistrationButtons, (el, i) => {
                el.addEventListener('click', (event) => {
                    this.proceedToExamRegistrationCheckout(event)
                })
            })
        }
    }

}

const cart = new ShopifyCart()
cart.bindPageHandlers()

export default cart
